/* global JitsiMeetJS */
import moment from 'moment';// require

export default {
    /**
     *
     * @param dateTime
     * @returns {string}
     */
    formatApiDate(dateTime) {
        return dateTime ? moment(dateTime).format('DD/MM/YYYY HH:mm') : '';
    },

    /**
     *
     * @param dateString
     * @returns {any}
     */
    parseApiDate(dateString) {
        return dateString ? moment(dateString, 'DD/MM/YYYY HH:mm').toDate() : '';
    },

    /**
     *
     * @param date
     * @returns {string}
     */
    formatDate(date) {
        return date ? moment(date).format('DD/MM/YYYY') : '';
    },

    /**
     *
     * @returns {string}
     */
    getLocalDate() {
        return moment().format('YYYY-MM-DD HH:mm:ss');
    },

    /**
     *
     * @returns {number}
     */
    getUTCTimestamp() {
        return Math.floor(Date.now() / 1000);
    }
};
